/**
 * Report job status values
 */
export enum ReportJobStatusEnum {
	/**
	 * Report job is queued
	 */
	QUEUED = 'queued',
	/**
	 * Report job is running
	 */
	RUNNING = 'running',
	/**
	 * Report job is completed
	 */
	COMPLETED = 'completed',
	/**
	 * Report job has failed
	 */
	FAILED = 'failed',
	/**
	 * Report job has been cancelled
	 */
	CANCELLED = 'cancelled',
}
